import React, { JSX } from 'react';
import { ProviderFiltersType } from 'components/types/FilterTypes';

type AvailabilityFilterProps = {
  filters: any;
  selectedFilters: ProviderFiltersType;
  replaceFilter: Function;
  setActiveFilterPanel: Function;
  updateFilter: Function;
};

const AvailabilityFilter = (props: AvailabilityFilterProps): JSX.Element => {
  const { filters, selectedFilters, updateFilter } = props;

  return (
    <>
      <div className="filter-availability">
        <div className="radio-wrapper">
          <input
            onChange={() => {
              updateFilter('availability', 'Next 24 Hours', {
                id: filters?.find(
                  (o: { text: string }) => o.text === 'Next 24 Hours'
                )?.id,
                text: filters?.find(
                  (o: { text: string }) => o.text === 'Next 24 Hours'
                )?.text,
                count: filters?.find(
                  (o: { text: string }) => o.text === 'Next 24 Hours'
                )?.count,
              });
            }}
            type="radio"
            id="availability-next-24-hours"
            checked={selectedFilters.availability[0] === 'Next 24 Hours'}
            name="Availability"
          />
          <label htmlFor="availability-next-24-hours">
            <span className="label-name">Next 24 Hours</span>&nbsp;
            <span className="label-number">
              (
              {filters?.find(
                (o: { text: string }) => o.text === 'Next 24 Hours'
              )
                ? filters?.find(
                    (o: { text: string }) => o.text === 'Next 24 Hours'
                  )?.count
                : '0'}
              )
            </span>
          </label>
        </div>
        <div className="radio-wrapper">
          <input
            onChange={() => {
              updateFilter('availability', 'Next 7 Days', {
                id: filters?.find(
                  (o: { text: string }) => o.text === 'Next 7 Days'
                )?.id,
                text: filters?.find(
                  (o: { text: string }) => o.text === 'Next 7 Days'
                )?.text,
                count: filters?.find(
                  (o: { text: string }) => o.text === 'Next 7 Days'
                )?.count,
              });
            }}
            type="radio"
            id="availability-next-7-days"
            checked={selectedFilters.availability[0] === 'Next 7 Days'}
            name="Availability"
          />
          <label htmlFor="availability-next-7-days">
            <span className="label-name">Next 7 Days</span>&nbsp;
            <span className="label-number">
              (
              {filters?.find((o: { text: string }) => o.text === 'Next 7 Days')
                ? filters?.find(
                    (o: { text: string }) => o.text === 'Next 7 Days'
                  )?.count
                : '0'}
              )
            </span>
          </label>
        </div>
        <div className="radio-wrapper">
          <input
            onChange={() => {
              updateFilter('availability', 'Next 14 Days', {
                id: filters?.find(
                  (o: { text: string }) => o.text === 'Next 14 Days'
                )?.id,
                text: filters?.find(
                  (o: { text: string }) => o.text === 'Next 14 Days'
                )?.text,
                count: filters?.find(
                  (o: { text: string }) => o.text === 'Next 14 Days'
                )?.count,
              });
            }}
            type="radio"
            id="availability-next-14-days"
            checked={selectedFilters.availability[0] === 'Next 14 Days'}
            name="Availability"
          />
          <label htmlFor="availability-next-14-days">
            <span className="label-name">Next 14 Days</span>&nbsp;
            <span className="label-number">
              (
              {filters?.find((o: { text: string }) => o.text === 'Next 14 Days')
                ? filters?.find(
                    (o: { text: string }) => o.text === 'Next 14 Days'
                  )?.count
                : '0'}
              )
            </span>
          </label>
        </div>
        <div className="radio-wrapper">
          <input
            onChange={() => {
              updateFilter('availability', 'Next 30 Days', {
                id: filters?.find(
                  (o: { text: string }) => o.text === 'Next 30 Days'
                )?.id,
                text: filters?.find(
                  (o: { text: string }) => o.text === 'Next 30 Days'
                )?.text,
                count: filters?.find(
                  (o: { text: string }) => o.text === 'Next 30 Days'
                )?.count,
              });
            }}
            type="radio"
            id="availability-next-30-days"
            checked={selectedFilters.availability[0] === 'Next 30 Days'}
            name="Availability"
          />
          <label htmlFor="availability-next-30-days">
            <span className="label-name">Next 30 Days</span>&nbsp;
            <span className="label-number">
              (
              {filters?.find((o: { text: string }) => o.text === 'Next 30 Days')
                ? filters?.find(
                    (o: { text: string }) => o.text === 'Next 30 Days'
                  )?.count
                : '0'}
              )
            </span>
          </label>
        </div>
        <div className="radio-wrapper">
          <input
            onChange={() => {
              updateFilter('availability', 'Next 60 Days', {
                id: filters?.find(
                  (o: { text: string }) => o.text === 'Next 60 Days'
                )?.id,
                text: filters?.find(
                  (o: { text: string }) => o.text === 'Next 60 Days'
                )?.text,
                count: filters?.find(
                  (o: { text: string }) => o.text === 'Next 60 Days'
                )?.count,
              });
            }}
            type="radio"
            id="availability-next-60-days"
            checked={selectedFilters.availability[0] === 'Next 60 Days'}
            name="Availability"
          />
          <label htmlFor="availability-next-60-days">
            <span className="label-name">Next 60 Days</span>&nbsp;
            <span className="label-number">
              (
              {filters?.find((o: { text: string }) => o.text === 'Next 60 Days')
                ? filters?.find(
                    (o: { text: string }) => o.text === 'Next 60 Days'
                  )?.count
                : '0'}
              )
            </span>
          </label>
        </div>
        <div className="radio-wrapper">
          <input
            onChange={() => {
              updateFilter('availability', 'Next 90 Days', {
                id: filters?.find(
                  (o: { text: string }) => o.text === 'Next 90 Days'
                )?.id,
                text: filters?.find(
                  (o: { text: string }) => o.text === 'Next 90 Days'
                )?.text,
                count: filters?.find(
                  (o: { text: string }) => o.text === 'Next 90 Days'
                )?.count,
              });
            }}
            type="radio"
            id="availability-next-90-days"
            checked={selectedFilters.availability[0] === 'Next 90 Days'}
            name="Availability"
          />
          <label htmlFor="availability-next-90-days">
            <span className="label-name">Next 90 Days</span>&nbsp;
            <span className="label-number">
              (
              {filters?.find((o: { text: string }) => o.text === 'Next 90 Days')
                ? filters?.find(
                    (o: { text: string }) => o.text === 'Next 90 Days'
                  )?.count
                : '0'}
              )
            </span>
          </label>
        </div>
      </div>
    </>
  );
};

export default AvailabilityFilter;
